import React from 'react';
import { useHistory } from 'react-router';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

import StepsBar from './StepsBar/StepsBar';
import { SelfServeWizardStep } from '../types';

type WizardProps = { currentStepIdentifier: string; wizardData: SelfServeWizardStep[] };

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const TitleWrapper = styled(T.Heading5)`
  font-weight: 600;
  margin-block-end: 32px;
`;

const DataComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const Wizard = ({ currentStepIdentifier, wizardData }: WizardProps) => {
  const history = useHistory();

  const hasWizardData = Boolean(wizardData.length);

  if (!hasWizardData) {
    return null;
  }

  const currentStepIndex = wizardData.findIndex(wizardEntry => wizardEntry.identifier === currentStepIdentifier);
  const currentStepData = wizardData[currentStepIndex];

  const goToPrevStep = () => history.push(`?step=${wizardData[currentStepIndex - 1].identifier}`);
  const goToNextStep = () => history.push(`?step=${wizardData[currentStepIndex + 1].identifier}`);

  return (
    <Wrapper>
      <StepsBar count={wizardData.length} currentStepIndex={currentStepIndex} />
      <TitleWrapper>{currentStepData.title}</TitleWrapper>

      <DataComponentWrapper>
        {React.createElement(currentStepData.component, { goToNextStep, goToPrevStep })}
      </DataComponentWrapper>
    </Wrapper>
  );
};

export default Wizard;
